import { createFileRoute, redirect } from '@tanstack/react-router';

import { generalAgentSections } from '@/features/general-agents';

/*
 * Bare `/general-agents/:id` redirects to the first section (profile), matching
 * the prototype's default-section behavior. The sectioned view lives in
 * `$generalAgentId/$section`.
 */
export const Route = createFileRoute('/_auth/general-agents/$generalAgentId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/general-agents/$generalAgentId/$section',
      params: {
        generalAgentId: params.generalAgentId,
        section: generalAgentSections[0]!.id,
      },
      replace: true,
    });
  },
});
